// import node module libraries
import { Fragment } from 'react';
import { Dropdown, Image } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

// import required hook
import useLocalStorage from 'hooks/useLocalStorage';

// import media files
import GlobeIcon from 'assets/images/svg/globe.svg';


const DropdownLanguage = () => {
	const { t, i18n } = useTranslation();
	const isDesktop = useMediaQuery({
		query: '(min-width: 1224px)'
	});

	return (
		<Fragment>
			<Dropdown as="li" className="ms-1">
				<Dropdown.Toggle
					as="a"
					bsPrefix=" "
					className="text-dark me-lg-1 btn btn-light btn-icon rounded-circle text-muted"
					id="dropdownLanguage"
				>
					<Image src={GlobeIcon} />
				</Dropdown.Toggle>
				<Dropdown.Menu
					show={isDesktop ? true : false}
					className="dashboard-dropdown dropdown-menu-end mt-3"
					aria-labelledby="dropdownLanguage"
					align="end"
				>
					<Dropdown.Header>
						{t('CHOOSE LANGUAGE')}
					</Dropdown.Header>
					<Dropdown.Item onClick={() => i18n.changeLanguage('en')}>
						English
					</Dropdown.Item>
					<Dropdown.Item onClick={() => i18n.changeLanguage('de')}>
						Deutsch
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</Fragment>
	);
};

export default DropdownLanguage;
